// Populates each .hero__flank-slot's .flank-photo links with a random,
// distinct sample of real products on every page load — shuffled and
// positioned here (not in Liquid) so the mix actually changes per load
// rather than being fixed at render time. See hero.liquid for the
// product JSON this reads from.
(function () {
  var dataEl = document.querySelector('[data-flank-photo-products]');
  var photoSlots = document.querySelectorAll('.hero__flank-slot');
  if (!dataEl || !photoSlots.length) return;

  var products;
  try {
    products = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!products.length) return;

  // Real print aspect ratio (28.5:19.02), same one the PDP and search
  // preview cards use — see .is-orientation-horizontal/-vertical in
  // theme.css — not an arbitrary box shape.
  var HORIZONTAL = { w: 162, h: 108 };
  var VERTICAL = { w: 108, h: 162 };
  var MIN_DURATION = 7;
  var MAX_DURATION = 11;

  var totalSlots = 0;
  photoSlots.forEach(function (slot) { totalSlots += slot.querySelectorAll('.flank-photo').length; });

  // Fisher-Yates, then take only as many as there are photo links —
  // guarantees no product repeats across slots (unless the catalog is
  // smaller than the slot count).
  var pool = products.slice();
  for (var i = pool.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = pool[i];
    pool[i] = pool[j];
    pool[j] = tmp;
  }
  var picks = pool.slice(0, totalSlots);
  var pickIndex = 0;

  // A fully independent random delay per photo (what this used to do)
  // can land any two photos at a similar height by pure chance, and
  // with only 8 photos that happens often enough to read as "lining
  // up in a row." Instead every photo gets a fixed, evenly-spaced slot
  // in a shared 0..1 phase cycle (0/8, 1/8, 2/8, ... — assigned across
  // BOTH sides, not reset per side, so left and right don't mirror
  // each other either), plus a little jitter so it doesn't look
  // mechanically evenly-ticked. Durations still vary per photo, so
  // this spacing gradually drifts over many cycles rather than staying
  // rigid forever — that's fine, it's the moment-to-moment clustering
  // that read badly, not long-run precision.
  //
  // Which phase slot goes to which physical column is itself shuffled
  // per page load (Fisher-Yates below) — otherwise phase 0/8 always
  // lands on the same DOM-order column (e.g. always the first photo in
  // the left slot), so that column's fall would start from roughly the
  // same height on every load even though its product/duration change.
  // Shuffling the assignment randomizes each column's starting position
  // along its own path while still keeping the even spacing that avoids
  // clustering.
  var phaseOrder = [];
  for (var p = 0; p < totalSlots; p++) phaseOrder.push(p);
  for (var pi = phaseOrder.length - 1; pi > 0; pi--) {
    var pj = Math.floor(Math.random() * (pi + 1));
    var ptmp = phaseOrder[pi];
    phaseOrder[pi] = phaseOrder[pj];
    phaseOrder[pj] = ptmp;
  }
  var phaseCursor = 0;

  photoSlots.forEach(function (slot) {
    var links = slot.querySelectorAll('.flank-photo');
    var slotWidth = slot.clientWidth;
    var n = links.length;

    // Pick a product/size for every photo first — the gap between them
    // depends on their combined width, so all sizes need to be known
    // before any position is computed.
    var items = [];
    links.forEach(function (el) {
      var product = picks[pickIndex % picks.length];
      pickIndex++;
      items.push({ el: el, product: product, size: product.orientation === 'vertical' ? VERTICAL : HORIZONTAL });
    });

    // Evenly spacing each photo's CENTER (as this used to do) doesn't
    // give evenly spaced EDGES once photos have different widths —
    // 72px and 108px photos next to each other end up with visibly
    // different gaps. Instead, lay them out left to right with one
    // shared gap, sized so the row fills the slot exactly edge to
    // edge: first photo flush left, last photo flush right, identical
    // spacing between every pair. If the four photos are collectively
    // wider than the slot (possible — the catalog is mostly
    // horizontal/108px, so 4-of-4 wide isn't rare), the gap goes
    // negative and they overlap by that same uniform amount instead of
    // the row ever exceeding the slot's own bounds.
    var totalWidth = items.reduce(function (sum, item) { return sum + item.size.w; }, 0);
    var gap = n > 1 ? (slotWidth - totalWidth) / (n - 1) : 0;
    var x = 0;

    items.forEach(function (item) {
      var el = item.el, product = item.product, size = item.size;
      var duration = MIN_DURATION + Math.random() * (MAX_DURATION - MIN_DURATION);
      var basePhase = phaseOrder[phaseCursor] / totalSlots;
      var jitter = (Math.random() - 0.5) * (1 / totalSlots) * 0.6;
      var delay = -((basePhase + jitter) * duration);
      phaseCursor++;

      el.href = product.url;
      el.style.width = size.w + 'px';
      el.style.height = size.h + 'px';
      el.style.marginTop = (-size.h / 2) + 'px';
      el.style.left = x + 'px';
      el.style.animationDuration = duration.toFixed(2) + 's, ' + duration.toFixed(2) + 's';
      el.style.animationDelay = delay.toFixed(2) + 's';

      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title;
      img.loading = 'lazy';
      el.appendChild(img);

      // flank-fade is opacity:0 at both 0% and 100%, so "animationiteration"
      // (which fires once per completed loop, for each animation-name) lands
      // exactly when the photo is invisible — swap the picture at that instant
      // so the next fade-in shows something new instead of the same photo
      // looping forever. Two animation-names (flank-move, flank-fade) share
      // one duration, so both fire an iteration event per cycle; only act on
      // one of them.
      el.addEventListener('animationiteration', function (evt) {
        if (evt.animationName !== 'flank-fade') return;
        if (products.length < 2) return;
        var next;
        do {
          next = products[Math.floor(Math.random() * products.length)];
        } while (next === product);
        product = next;
        el.href = product.url;
        img.src = product.image;
        img.alt = product.title;
      });

      x += size.w + gap;
    });
  });
})();
